// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
    margin: 0 auto;
    padding: 0 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
  }
  
  .navbar {
    height: 150px;
    background-color: #f9e4bc;
    position: absolute;
    width: 100%;
    box-shadow: 0px 4px 5px black;
    z-index: 1;
  }

  #nav-row-container{
    margin-top: 40px;
  }

  #all-pages-link{
    width: 120px;
  }
  
  .nav-elements ul {
    display: flex;
    justify-content: space-between;
    list-style-type: none;
    position: absolute;
    right: 45px;
    z-index: 1;
  }
  
  .nav-elements ul li:not(:last-child) {
    margin-right: 35px;
    width: 70px;
    z-index: 1;
  }
  
  .nav-elements ul a {
    font-size: 25px;
    font-weight: 400;
    color: rgb(90, 121, 147);
    text-decoration: none;
    z-index: 1;
  }
  
  .nav-elements ul a.active {
    color: rgb(90, 121, 147);
    font-weight: 500;
    position: relative;
    z-index: 1;
  }
  
  .nav-elements ul a.active::after {
    position: absolute;
    bottom: -4px;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: rgb(90, 121, 147);
    z-index: 1;
  }

  #logo {
    height: 100px;
    position: relative;
    top: -20px;
    cursor: pointer;
    left: -15px;
  }

  #wide-nav {
    padding-left: 62%;
  }

  .menu-icon {
    display: none;
  }

  #dropdown-content{
    display: none;
    flex-direction: column;
    background-color: white;
    opacity: .9;
    text-align: end;
    width: 120%;
    padding-right: 10px;
    z-index: 1;
  }

  .other-pages-links{
    color: white;
    z-index: 1;
  }

  .condensed-dropdown{
    display: none;
    z-index: 1;
  }

  #dropdown{
    color: white;
    z-index: 1;
  }



@media (max-width: 1200px) {

    .menu-icon {
      position: absolute;
      display: block;
      left: 80%;
      top: 20%;
    }

    .condensed-dropdown{
      display: flex;
      text-decoration: none;
      z-index: 1;
    }

    .nav-elements {
      position: absolute;
      right: 0;
      top: 105px;
      background-color: white;
      width: 0px;
      opacity: .9;
      height: 110vh;
      transition: all 0.3s ease-in;
      overflow: hidden;
      z-index: 1;
    }
  
    .nav-elements.active {
      width: 270px;
      z-index: 1;
      height: 801px;
    }
  
    .nav-elements ul {
      display: flex;
      flex-direction: column;
      z-index: 1;
    }
  
    .nav-elements ul li {
      margin-right: unset;
      margin-top: 22px;
      z-index: 1;
    }

    #hamburger {
      text-align: right;
      position: relative;
      right: 20px;
    }

    #bar1 {
      height: 8px;
      width: 50px;
      background-color: rgb(90, 121, 147);
      margin-top: 30px;
    }
    
    #bar2 {
      height: 8px;
      width: 50px;
      margin-top: 5px;
      background-color: rgb(90, 121, 147);
    }
    
    #bar3 {
      height: 8px;
      width: 50px;
      margin-top: 5px;
      background-color: rgb(90, 121, 147);
    }

    #all-pages-link{
      display: none;
    }

    #menu-icon{
      z-index: 1;
    }

  }

@media (max-width: 775px) {
  .nav-elements {
    position: absolute;
    right: 0;
    top: 5px;
    background-color: white;
    width: 0px;
    opacity: .95;
    height: 91vh;
    transition: all 0.3s ease-in;
    overflow: hidden;
    z-index: 1;
  }

  #menu-icon{
    z-index: 1;
  }

  .nav-elements.active {
    width: 270px;
    z-index: 1;
  }

  .nav-elements ul {
    display: flex;
    flex-direction: column;
    z-index: 1;
  }

  .nav-elements ul li {
    margin-right: unset;
    margin-top: 22px;
    z-index: 1;
  }

  
}`, "",{"version":3,"sources":["webpack://./src/components/ResponsiveAppBar.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,6BAA6B;IAC7B,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,WAAW;IACX,WAAW;IACX,mCAAmC;IACnC,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,UAAU;EACZ;;;;AAIF;;IAEI;MACE,kBAAkB;MAClB,cAAc;MACd,SAAS;MACT,QAAQ;IACV;;IAEA;MACE,aAAa;MACb,qBAAqB;MACrB,UAAU;IACZ;;IAEA;MACE,kBAAkB;MAClB,QAAQ;MACR,UAAU;MACV,uBAAuB;MACvB,UAAU;MACV,WAAW;MACX,aAAa;MACb,4BAA4B;MAC5B,gBAAgB;MAChB,UAAU;IACZ;;IAEA;MACE,YAAY;MACZ,UAAU;MACV,aAAa;IACf;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,UAAU;IACZ;;IAEA;MACE,mBAAmB;MACnB,gBAAgB;MAChB,UAAU;IACZ;;IAEA;MACE,iBAAiB;MACjB,kBAAkB;MAClB,WAAW;IACb;;IAEA;MACE,WAAW;MACX,WAAW;MACX,mCAAmC;MACnC,gBAAgB;IAClB;;IAEA;MACE,WAAW;MACX,WAAW;MACX,eAAe;MACf,mCAAmC;IACrC;;IAEA;MACE,WAAW;MACX,WAAW;MACX,eAAe;MACf,mCAAmC;IACrC;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,UAAU;IACZ;;EAEF;;AAEF;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,uBAAuB;IACvB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,4BAA4B;IAC5B,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;EACZ;;;AAGF","sourcesContent":[".container {\n    margin: 0 auto;\n    padding: 0 15px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 100%;\n  }\n  \n  .navbar {\n    height: 150px;\n    background-color: #f9e4bc;\n    position: absolute;\n    width: 100%;\n    box-shadow: 0px 4px 5px black;\n    z-index: 1;\n  }\n\n  #nav-row-container{\n    margin-top: 40px;\n  }\n\n  #all-pages-link{\n    width: 120px;\n  }\n  \n  .nav-elements ul {\n    display: flex;\n    justify-content: space-between;\n    list-style-type: none;\n    position: absolute;\n    right: 45px;\n    z-index: 1;\n  }\n  \n  .nav-elements ul li:not(:last-child) {\n    margin-right: 35px;\n    width: 70px;\n    z-index: 1;\n  }\n  \n  .nav-elements ul a {\n    font-size: 25px;\n    font-weight: 400;\n    color: rgb(90, 121, 147);\n    text-decoration: none;\n    z-index: 1;\n  }\n  \n  .nav-elements ul a.active {\n    color: rgb(90, 121, 147);\n    font-weight: 500;\n    position: relative;\n    z-index: 1;\n  }\n  \n  .nav-elements ul a.active::after {\n    position: absolute;\n    bottom: -4px;\n    left: 0;\n    width: 100%;\n    height: 2px;\n    background-color: rgb(90, 121, 147);\n    z-index: 1;\n  }\n\n  #logo {\n    height: 100px;\n    position: relative;\n    top: -20px;\n    cursor: pointer;\n    left: -15px;\n  }\n\n  #wide-nav {\n    padding-left: 62%;\n  }\n\n  .menu-icon {\n    display: none;\n  }\n\n  #dropdown-content{\n    display: none;\n    flex-direction: column;\n    background-color: white;\n    opacity: .9;\n    text-align: end;\n    width: 120%;\n    padding-right: 10px;\n    z-index: 1;\n  }\n\n  .other-pages-links{\n    color: white;\n    z-index: 1;\n  }\n\n  .condensed-dropdown{\n    display: none;\n    z-index: 1;\n  }\n\n  #dropdown{\n    color: white;\n    z-index: 1;\n  }\n\n\n\n@media (max-width: 1200px) {\n\n    .menu-icon {\n      position: absolute;\n      display: block;\n      left: 80%;\n      top: 20%;\n    }\n\n    .condensed-dropdown{\n      display: flex;\n      text-decoration: none;\n      z-index: 1;\n    }\n\n    .nav-elements {\n      position: absolute;\n      right: 0;\n      top: 105px;\n      background-color: white;\n      width: 0px;\n      opacity: .9;\n      height: 110vh;\n      transition: all 0.3s ease-in;\n      overflow: hidden;\n      z-index: 1;\n    }\n  \n    .nav-elements.active {\n      width: 270px;\n      z-index: 1;\n      height: 801px;\n    }\n  \n    .nav-elements ul {\n      display: flex;\n      flex-direction: column;\n      z-index: 1;\n    }\n  \n    .nav-elements ul li {\n      margin-right: unset;\n      margin-top: 22px;\n      z-index: 1;\n    }\n\n    #hamburger {\n      text-align: right;\n      position: relative;\n      right: 20px;\n    }\n\n    #bar1 {\n      height: 8px;\n      width: 50px;\n      background-color: rgb(90, 121, 147);\n      margin-top: 30px;\n    }\n    \n    #bar2 {\n      height: 8px;\n      width: 50px;\n      margin-top: 5px;\n      background-color: rgb(90, 121, 147);\n    }\n    \n    #bar3 {\n      height: 8px;\n      width: 50px;\n      margin-top: 5px;\n      background-color: rgb(90, 121, 147);\n    }\n\n    #all-pages-link{\n      display: none;\n    }\n\n    #menu-icon{\n      z-index: 1;\n    }\n\n  }\n\n@media (max-width: 775px) {\n  .nav-elements {\n    position: absolute;\n    right: 0;\n    top: 5px;\n    background-color: white;\n    width: 0px;\n    opacity: .95;\n    height: 91vh;\n    transition: all 0.3s ease-in;\n    overflow: hidden;\n    z-index: 1;\n  }\n\n  #menu-icon{\n    z-index: 1;\n  }\n\n  .nav-elements.active {\n    width: 270px;\n    z-index: 1;\n  }\n\n  .nav-elements ul {\n    display: flex;\n    flex-direction: column;\n    z-index: 1;\n  }\n\n  .nav-elements ul li {\n    margin-right: unset;\n    margin-top: 22px;\n    z-index: 1;\n  }\n\n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
